import {
  ApplicationRef,
  createComponent,
  EmbeddedViewRef,
  EnvironmentInjector,
  inject,
  Injectable,
  Injector,
  Type,
} from '@angular/core';
import { ModalRef } from './modal-ref';
import { MODAL_DATA } from './modal-tokens';
import { ModalConfig } from './modal-config';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private readonly appRef = inject(ApplicationRef);
  private readonly envInjector = inject(EnvironmentInjector);
  private readonly injector = inject(Injector);

  open<T, D = unknown, R = unknown>(
    component: Type<T>,
    config?: ModalConfig<D>,
  ): ModalRef<R> {
    const modalRef = new ModalRef<R>();

    const elementInjector = Injector.create({
      providers: [
        { provide: ModalRef, useValue: modalRef },
        { provide: MODAL_DATA, useValue: config?.data ?? null },
      ],
      parent: this.injector,
    });

    const componentRef = createComponent(component, {
      environmentInjector: this.envInjector,
      elementInjector,
    });

    modalRef.componentInstance = componentRef.instance;

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    modalRef._destroy = () => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
      domElem.remove();
    };

    return modalRef;
  }
}
